import React from "react";

import {
  Card,
  CardBody,
  CardTitle,
  Content,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ExternalLinkAltIcon,
  PhoneAltIcon
} from "@patternfly/react-icons";

import {
  dentalOffice,
  healthDocuments
} from "./data/healthData";

const HealthPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <Grid>
            <GridItem
              span={10}
              offset={1}
              md={8}
              mdOffset={2}
            >
              <Stack hasGutter>
                <StackItem>
                  <Content
                    component="h1"
                    style={{ textAlign: "center" }}
                  >
                    Zdrowie
                  </Content>
                </StackItem>

                <StackItem>
                  <Content
                    component="p"
                    style={{ textAlign: "center" }}
                  >
                    Informacje dotyczące opieki stomatologicznej
                    dla uczniów szkoły.
                  </Content>
                </StackItem>
              </Stack>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardTitle>
                  {dentalOffice.title}
                </CardTitle>

                <CardBody>
                  <Stack hasGutter>
                    <StackItem>
                      <Content component="p">
                        <strong>
                          {dentalOffice.description}
                        </strong>
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content>
                        <Content component="h3">
                          Adres
                        </Content>

                        {dentalOffice.address.map((line) => (
                          <Content
                            component="p"
                            key={line}
                          >
                            {line}
                          </Content>
                        ))}
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content component="p">
                        <PhoneAltIcon />{" "}
                        <Content component="a" href={`tel:${dentalOffice.phone.replace(/\s/g, "")}`}>
                          {dentalOffice.phone}
                        </Content>
                      </Content>
                    </StackItem>

                    <StackItem>
                      <Content component="p">
                        <Content component="a"
                          href={dentalOffice.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {dentalOffice.website}{" "}
                          <ExternalLinkAltIcon />
                        </Content>
                      </Content>
                    </StackItem>
                  </Stack>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={8}
              mdOffset={2}
            >
              <Card isGlass>
                <CardTitle>
                  Dokumenty
                </CardTitle>

                <CardBody>
                  <Content>
                    <List isPlain>
                      {healthDocuments.map((document) => (
                        <ListItem key={document.id}>
                          <a
                            href={document.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {document.title}{" "}
                            <ExternalLinkAltIcon />
                          </a>
                        </ListItem>
                      ))}
                    </List>
                  </Content>
                </CardBody>
              </Card>
            </GridItem>
          </Grid>
        </StackItem>
      </Stack>
    </PageSection>
  );
};

export default HealthPage;